import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Appointment } from './appointments';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AppointmentsService {
  private readonly http = inject(HttpClient);

  list(): Observable<Appointment[]> {
    return this.http
      .get<Appointment[] | { results?: Appointment[] }>(
        `${environment.apps.apiWorkplace.url}/api/v3/appointments/`
      )
      .pipe(map(body => (Array.isArray(body) ? body : (body.results ?? []))));
  }
}
